/**
 * scripts.js
 */
(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.fut = {
    attach(context, settings) {
      $('.show-team').click(function (e) {
        // $('.team-wrapp-' + $(this).attr('aria-controls')).addClass('showed');
        e.preventDefault();

        // Extract the original aria-controls value
        let originalId = this.getAttribute('aria-controls'); // e.g., "collapse-28-3622"

        // Extract numbers and rearrange them to match Bootstrap ID format
        let match = originalId.match(/collapse-(\d+)-(\d+)/);
        if (match) {
          let newId = `collapse-${match[2]}-${match[1]}`; // "collapse-3622-28"

          let collapseElement = document.getElementById(newId);
          if (collapseElement) {
            // Toggle Bootstrap Collapse
            let bsCollapse = new bootstrap.Collapse(collapseElement, {
              toggle: true
            });
          }
        }
      });
    }
  }


})(jQuery, Drupal, drupalSettings, once);
